import AppShell from "@/app-shell";
import { router } from "@/router";

import { RouterProvider } from "react-router/dom";

export default function App() {
  return (
    <AppShell>
      <RouterProvider router={router} />
    </AppShell>
  );
}
